import React, { useState, useEffect, useContext } from "react";
import { fetchAPI } from "@/utility/NetworkUtils";
import UserContext from "@/context/UserContext";
import PublicCatalogLayout from "@/layouts/PublicCatalogLayout";
import { renderButton } from "@/shared/FormUtils";
import Stack from '@mui/material/Stack';
import { canEditItem, canUserAddItemToEvent, canUserAddItemToCart, isJaguar } from "@/utility/UserUtils";
import ItemCost from "./components/ItemCost";
import ItemImageComponent from "./components/ItemImageComponent";
import InventoryChits from "./components/InventoryChits";
import Modal from "react-modal";
import AddToCartForm from './form/AddToCartForm';
import ItemHoldFormRevised from './form/ItemHoldFormRevised';
import ItemUpdatedAtComponent from "./components/ItemUpdatedAtComponent";
import { Checkbox } from "@mui/material";
const ItemShowPageRevised = (props) => {
  const { item, user } = props;
  const [ page, setPage ] = useState(null)

  const renderButtons = () => {
    if(item.deleted_at) return
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {canEditItem(item, user) &&
          renderButton("Edit Item", ()=>{
            window.location.href = (isJaguar(user) || item.renter_id == null) ? `/management/items/${item.id}/edit` : `/inventory/${item.renter_id}/items/${item.id}/edit` 
          }, {color:"green"})
        }
        {canUserAddItemToCart(user, item) &&
        renderButton("Add to Order", ()=>{
          setPage("add_to_cart")
        }, {color:"darkGreen"})}
        {canUserAddItemToEvent(user, item) &&
        renderButton("Add to Event", ()=>{
          setPage("add_to_event")
        }, {color:"burgandy"})}
                
      </Stack>
    )
  }


  const renderInventoryCounts = () => {
    if(item.deleted_at) {
      return (
        <div className="px-[16px] py-[12px] text-white bg-red-600 inline-block text-xl font-medium">
          This item has been deleted
        </div>
      )
    }
    return (
      <InventoryChits
        item={item}
      />
    )
  }
  
  
  const getBreadcrumbs = () => {
    let breadcrumbs = []
    breadcrumbs.push({
      name: "Inventory",
      url: "/"
    })

    if(item.category) {
      breadcrumbs.push({
        name: item.category.group_name,
        url: item.category.renter_id ? `/inventory/${item.category.renter_id}/category/${item.category.group_name}` : `/category/${item.category.group_name}`
      })
      breadcrumbs.push({
        name: item.name
      })
    }
    return breadcrumbs
  }

  const closeModal = () => {
    setPage(null)
  }

  const renderCustomFields = () => {
    let customFields = []
    if(isJaguar(user) && item.custom_fields) {
      //Check if custom fields is a string
      if(typeof item.custom_fields == "string") {
        try {
          customFields = JSON.parse(item.custom_fields).fields
        } catch (error) {
          console.log(error)
        }
      }else {
        customFields = item.custom_fields
      }
      if(customFields) {
        return customFields.map(field => (
          renderDetail(field.name, field.value)
        ));
      }
    }
  }

  const renderDetail = (label, value) => {
    return (
      <div className="quickview-field">
        {label}: <span className="inline"> {value} </span>
      </div>
    )
  }

  const renderSize = () => {
    const dimensions = [item.product_width, item.product_height, item.product_length].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      if(item.size_type) {
        value = dimensions.map(x=>x+'ft.').join(" x ")
      }else {
        value = dimensions.map(x=>x+'"').join(" x ")
      }
      return value
    }
  }

  const renderCartonSize = () => {
    const dimensions = [item.carton_length, item.carton_width, item.carton_height].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      value = dimensions.map(x=>x+'"').join(" x ")
      return value
    }

  }


  const renderInfo = () => {
    const size = renderSize()
    const cartonSize = renderCartonSize()

    return (
      
      <div className="flex flex-col flex-wrap h-full">
        <div>
          {renderInventoryCounts()}
          </div>
          <div className="mt-[40px]"/>
        {renderDetail("Owner", item.renter?.name || "Jaguar Design Studio")}
        {renderDetail("Category / Subcategory", item.category ? `${item.category.group_name} / ${item.category.name}` : "Other")}
        <div className="mt-3"/>
        {item.description && renderDetail("Description", (item.description||"").split("\n").map((x,i) => <div key={i}>{x}</div>))}
        <div className="mt-3"/>
        {item.color && renderDetail("Color", item.color)}
        {item.apparel_gender && renderDetail("Apparel Gender", item.apparel_gender)}
        {item.apparel_size && renderDetail("Apparel Size", item.apparel_size)}
        {size && renderDetail("Size", size)}
        {isJaguar(user) && item.brand && renderDetail("Brand", item.brand)}
        {renderCustomFields()}
        {isJaguar(user) && (item.purchase_cost || item.purchase_link || item.trax_link) ? (
          <>
          <div className="mt-3"/>
          {item.purchase_cost && renderDetail("Purchase Price", "$"+
            parseFloat(item.purchase_cost).toFixed(2)
          )}
          {item.purchase_link && renderDetail("Purchase Link", (
            <a href={item.purchase_link} target="_blank">Link</a>
          ))}
          {item.trax_link && renderDetail("Trax Link", (
            <a href={item.trax_link} target="_blank">Link</a>
          ))}
          </>
        ):""}
        <div className="mt-3"/>
        {isJaguar(user) && item.internal_notes && renderDetail("Internal Notes", (item.internal_notes).split("\n").map((x,i) => <div key={i}>{x}</div>))}
        {isJaguar(user) && item.internal_notes && (<div className="mt-3"/>)}
        {isJaguar(user) && cartonSize && renderDetail("Carton Size", cartonSize)}
        {isJaguar(user) && item.warehouse_location && renderDetail("Warehouse Location", item.warehouse_location)}
        {isJaguar(user) && renderDetail("Audited inventory 2025", (
          <Checkbox
            checked={item.audited_2025}
            disabled={true}
            color="green"
            className="inline-block mt-1 h-1 mt-[-25px] ml-[-5px]"
          />
        ))}
        {isJaguar(user) && renderDetail("Audited inventory 2026", (
          <Checkbox
            checked={item.audited_2026}
            disabled={true}
            color="green"
            className="inline-block h-1 mt-[-25px] ml-[-5px]"
          />
        ))}
        <div className="mt-3"/>
        {isJaguar(user) && item.item_attachments && item.item_attachments.length > 0 && renderAttachments()}
          {isJaguar(user) && (
          <ItemUpdatedAtComponent item={item} />
        )}
        <div className="mb-[37px]"/>

      </div>
    )
  }

  const renderAttachments = () => {
    return (
      <div className="quickview-field">
        Attachments:
        {item.item_attachments.map(attachment =>
          <span className="item-attachment">
            <a href={attachment.attachment} target="_blank">
              {attachment.label}
            </a>
          </span>
        )}
      </div>
    )
  }

  const renderModal = () => {
    return (
      <Modal
        className="react-modal item-card-quick-view-modal"
        overlayClassName="react-modal-overlay"
        isOpen={page != null}
        onRequestClose={closeModal}
        contentLabel="Item Modal"
      >
        {page == "add_to_cart" && <AddToCartForm item={item} onCancel={()=>setPage(null)} onSubmit={closeModal} />}
        {page == "add_to_event" && <ItemHoldFormRevised item={item} onCancel={()=>setPage(null)} onSubmit={closeModal} />}
      </Modal>
    )
  }
  return (
    <PublicCatalogLayout
      {...props}
      breadcrumbs={ getBreadcrumbs() }
      currentPage={
        `group-${item.category && item.category.group_name ? item.category.group_name : "other"}`
      }
      classNames={{body: 'white-background'}}
    >
      {renderModal()}
      <div className="row pt-8">
        <div className="pull-right col-xs-12 col-sm-5">
          {renderButtons()}
        </div>
        <div className="col-xs-12 col-sm-7">
          <div class="text-emerald-900 text-[34px] font-medium font-['Roboto'] pb-4 font-weight-[400]">
            {item.name}
          </div>
          <ItemCost item={item} />
        </div>
      </div>

      <div className="row flex">
        <div className="col-xs-5">
          <ItemImageComponent item={item} />
        </div>
        <div className="col-xs-7">
        
          {renderInfo()}
        </div>
      </div>
    </PublicCatalogLayout>
  );
};

export default ItemShowPageRevised;